export default "__VITE_ASSET__C6Mywwzh__";